export const getSingleChallengeFetching = state => state?.challenges?.singleFetching;

export const getChallengeData = (state, iri) => state.challenges?.[iri];

export const getChallengeTypes = state => state.challenges.challengeTypes;

export const getChallengeTypesFetching = state => state.challenges.challengeTypesFetching;
